import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductHighlight from './components/ProductHighlight';
import Products from './components/Products';
import VideoHighlight from './components/VideoHighlight';
import AnimalWelfare from './components/AnimalWelfare';
import Community from './components/Community';
import Story from './components/Story';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <ProductHighlight />
      <Products />
      <VideoHighlight />
      <AnimalWelfare />
      <Community />
      <Story />
      <Testimonials />
      <Contact />
      <Footer />
      <Chatbot />
    </div>
  );
}

export default App;

